import React, { useEffect, useMemo, useRef, useState } from "react";
import { Form, Formik } from "formik";
import "./appointment-create-form.scss";
import { appointmentCreate } from "../../service/api/appointment-api";
import { useDispatch, useSelector } from "react-redux";
// import Select from "react-select";
import { getLocations } from "../../store/slices/locationSlice";
import SelectWithLocalSearch from "../common/updated-input/select-with-local-search/select-with-local-search";
import { convertAgeToDob, convertDobToAge, convertDobToAgeYearMonth, convertAgeToDobYearMonth } from "../../utils/common-funtions/common";
import { Toast } from "../../utils/SwalUti";
import { useMatch } from "react-router-dom";
import { Select } from "antd";
import CreatableSearchSelect from "../common/updated-input/createble-search-select/creatable-search-select";
import { get, post } from "../../utils/fetchAPI";
import { getOccupations, createOccupation } from "../../service/api/occupation-api";

const VISIT_TYPES = ["new", "old", "followUp"];

const AppointmentCreateForm = ({
    selectedPatientInfo, isNewUser, setSinglePatientInfo, setIsNewUser, refresh, setShow,
}) => {
    const [info, setInfo] = useState({ appointmentDate: new Date().toJSON(), gender: "Male", type: "new" });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [date] = useState(new Date().toJSON());
    const { user, userRoles, selectedRole, selectedDoctor } = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const [seletedDistrict, setSelectedDistrict] = useState({})
    const [referralList, setReferralList] = useState([])
    const [occupationList, setOccupationList] = useState([])
    const [referral, setReferral] = useState("")
    const timeoutIdRef = useRef(null)
    const [age, setAge] = useState({
        age: 0,
        ageUnit: "year(s)"
    })
    let { districtList } = useSelector(
        (state) => state.visit
    );

    let { isLoading, allLocations, noLocationFound, locationOptions } = useSelector(
        (state) => state.location
    );
    const maritalStatusOptions = [
        {
            id: 1,
            name: "Married",
            value: "married"
        },
        {
            id: 2,
            name: "Unmarried",
            value: "unmarried"
        },
    ]

    useEffect(() => {
        const doctorId = getDoctorId();
        if (doctorId) getRefferalList(doctorId);
        getOccupationList(getOccupationDoctorId());
    }, [info?.doctorId, user?.user?._id, selectedDoctor?._id]);

    useEffect(() => {
        if (selectedPatientInfo?.name) {
            setInfo((prev) => ({
                ...selectedPatientInfo,
                appointmentDate: date,
                type: VISIT_TYPES.includes(prev?.type) ? prev.type : "new",
            }));
            let currentAge = convertDobToAgeYearMonth(selectedPatientInfo?.dob, age?.ageUnit) || ""
            let splitCurrentAge = currentAge?.split(" ")
            setAge({
                age: splitCurrentAge[0], ageUnit: splitCurrentAge[1]
            })
        } else {
            setInfo({ appointmentDate: new Date().toJSON(), gender: "Male", type: "new" });
        }
        if (selectedPatientInfo?.district?._id) {
            setSelectedDistrict({ label: selectedPatientInfo?.district?.name, value: selectedPatientInfo?.district?._id })
        }
    }, [selectedPatientInfo?.name]);


    const onSubmit = async (values, { resetForm }) => {
        if (!VISIT_TYPES.includes(info?.type)) {
            Toast.fire({
                icon: "warning",
                title: "Please select a visit type",
            });
            return;
        }
        let { age, ...payload } = info
        if (referral) payload.referredBy = referral;
        values = payload;
        if (user?.user?.type?.toLowerCase() === "doctor") {
            values.doctorId = user?.user?._id;
            values.officeLocationId = selectedRole?.location?._id
        } else {
            // Staff / assistant: book on behalf of the selected (tagged) doctor.
            values.doctorId = info?.doctorId || selectedDoctor?._id;
            values.officeLocationId = selectedRole?.location?._id
        }

        if (!values.doctorId) {
            Toast.fire({ icon: "warning", title: "Please select a doctor" });
            return;
        }
        setIsSubmitting(true)

        await appointmentCreate(values)
            .then((res) => {
                if (res.status === 200) {
                    resetForm();
                    setIsNewUser(false);
                    setIsSubmitting(false);
                    refresh();
                    setShow(false);
                    Toast.fire({
                        icon: '',
                        title: "New appointment created successfully"
                    })
                }
            })
            .catch((error) => {
                setIsSubmitting(false);
            }).finally(() => {
                setIsSubmitting(false);
            });
    };
    const setInfoFun = (key, value) => {
        let temp = { ...info };
        setInfo({ ...temp, [key]: value });
    };


    const setDobAgeInfoFun = (key, value) => {
        let temp = { ...info };
        if (key == "dob") {
            let currentAge = convertDobToAgeYearMonth(value, age?.ageUnit)
            setInfo({ ...temp, dob: value });
            let splitCurrentAge = currentAge?.split(" ")
            setAge({
                age: splitCurrentAge[0], ageUnit: splitCurrentAge[1]
            })
        } else if (key == "ageUnit") {
            setInfo({ ...temp, dob: convertAgeToDobYearMonth(age?.age, value), age: age?.age + " " + value });
            setAge({ ...age, ageUnit: value })
        } else {
            setInfo({ ...temp, dob: convertAgeToDobYearMonth(value, age?.ageUnit), age: value + " " + age?.ageUnit });
            setAge({ ...age, age: value })
        }
    };

    const getDoctorId = () => info?.doctorId || user?.user?._id;

    const getRefferalList = async (doctorId = getDoctorId(), search = "") => {
        if (!doctorId) return;
        await get(`/doctor/referral/${doctorId}?search=${search}`)
            .then((res) => {
                if (res?.status == 200) setReferralList(res?.data);
            })
            .catch(() => { });
    };

    const addReferral = async (doctorId, details) => {
        await post(`/doctor/referral/create`, { doctorId, details })
            .then((res) => {
                if (res?.status == 200) getRefferalList();
            })
            .catch(() => { });
    };

    // Occupations belong to the doctor the appointment is for, which is not the
    // logged-in user when staff book on a doctor's behalf. Mirrors onSubmit.
    const getOccupationDoctorId = () =>
        user?.user?.type?.toLowerCase() === "doctor"
            ? user?.user?._id
            : info?.doctorId || selectedDoctor?._id;

    // Seeded defaults + this doctor's own additions.
    const getOccupationList = async (doctorId = getOccupationDoctorId()) => {
        await getOccupations(doctorId)
            .then((res) => {
                if (res?.status == 200) setOccupationList(res?.data || []);
            })
            .catch(() => { });
    };

    // Typed occupation matched no suggestion — save it against this doctor.
    const handleCreateOccupation = async (name) => {
        setInfoFun("profession", name);
        const doctorId = getOccupationDoctorId();
        if (!doctorId) return;
        await createOccupation({ doctorId, name })
            .then((res) => {
                if (res?.status == 200) getOccupationList();
            })
            .catch(() => { });
    };

    // Older patients stored the slug ("garments_worker"); show the label for those too.
    const occupationLabel = useMemo(() => {
        if (!info?.profession) return "";
        const match = occupationList.find(
            (option) => option?.value === info.profession || option?.name === info.profession
        );
        return match?.name || info.profession;
    }, [info?.profession, occupationList]);

    const setRefferalListFun = (event) => {
        event.preventDefault();
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(() => { getRefferalList(getDoctorId(), event?.target?.value); }, 800);
    };

    const handleAddToPrescription = (value) => {
        setReferral(referral + (referral?.length >= 2 ? "\n" : "") + value?.details);
    };

    const handleCreateReferral = (value) => {
        setReferral(referral + (referral?.length >= 2 ? "\n" : "") + value);
        addReferral(getDoctorId(), value);
    };

    const onChange = (value, option) => {
        setSelectedDistrict({ label: option?.label, value: value })
        setInfo({ ...info, district: value });
    };


    return (
        <Formik
            initialValues={{
                name: "",
                phone: "",
                email: "",
                gender: "",
                dob: "",
                bloodGroup: "",
                maritalStatus: ""
            }}
            onSubmit={onSubmit}
        >
            {(formik) => (
                <div className="appointment-create-form-section appointment-create-form pb-0 p-0 m-0">
                    <Form
                        action=""
                        id=""
                        className="custom-form input-section appointment-create-form__form position-relative"
                        encType="multipart/form-data"
                    >
                        <div className="row mt-0 pt-0 g-1">
                            <div className="col-12 appointment-create-form__panel">
                            <h3 className="appointment-create-form__section-title">Patient</h3>
                            <div className="col-12 appointment-create-form__row">
                                <label htmlFor="name" className="appointment-create-form__label">
                                    Name<span className="text-danger">*</span>
                                </label>
                                <input
                                    required
                                    className="form-control input appointment-create-form__control"
                                    autoComplete="off"
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={info?.name || ""}
                                    placeholder="Enter name"
                                    onChange={(e) => {
                                        setInfoFun("name", e.target.value);
                                    }}
                                />
                            </div>
                            <div className="col-12 appointment-create-form__row">
                                <label htmlFor="patientId" className="appointment-create-form__label">
                                    Patient ID
                                </label>
                                <input
                                    className="form-control input appointment-create-form__control"
                                    autoComplete="off"
                                    type="string"
                                    id="patientId"
                                    name="patientId"
                                    disabled
                                    placeholder="Assigned when saved"
                                    value={info?.patientId || ""}
                                    onChange={(e) => {
                                        setInfoFun("patientId", e.target.value);
                                    }}
                                />
                            </div>
                            <div className="col-12 appointment-create-form__row">
                                <label htmlFor="phone" className="appointment-create-form__label">
                                    Phone
                                </label>
                                <input
                                    className="form-control input appointment-create-form__control"
                                    autoComplete="off"
                                    // pattern="(^(01){1}[3-9]{1}\d{8})$"
                                    type="text"
                                    id="phone"
                                    name="phone"
                                    placeholder="Enter phone number"
                                    value={info.phone || ""}
                                    onChange={(e) => {
                                        setInfoFun("phone", e.target.value);
                                    }}
                                />
                            </div>

                            <div className="col-12 appointment-create-form__row">
                                <label htmlFor="email" className="appointment-create-form__label">
                                    Email
                                </label>
                                <input
                                    className="form-control input appointment-create-form__control"
                                    autoComplete="off"
                                    type="email"
                                    id="email"
                                    name="email"
                                    placeholder="Enter email"
                                    value={info?.email || ""}
                                    onChange={(e) => {
                                        setInfoFun("email", e.target.value);
                                    }}
                                />
                            </div>

                            <div className="col-12 appointment-create-form__row appointment-create-form__row--age">
                                <label htmlFor="age-input" className="appointment-create-form__label">
                                    Age<span className="text-danger">*</span>
                                </label>
                                <div className="appointment-create-form__age-inputs">
                                <input
                                    id="age-input"
                                    required
                                    className="form-control input appointment-create-form__control appointment-create-form__control--age"
                                    autoComplete="off"
                                    type="number"
                                    name="age"
                                    placeholder="Age"
                                    value={age?.age || ""}
                                    onChange={(e) => {
                                        setDobAgeInfoFun("age", e.target.value);
                                    }}
                                />
                                <select
                                    className="appointment-create-form__age-unit"
                                    onChange={(e) => {
                                        setDobAgeInfoFun("ageUnit", e.target.value);
                                    }}
                                    value={age?.ageUnit || ""}
                                >
                                    <option value={'year(s)'}>year(s)</option>
                                    <option value={'month(s)'}>month(s)</option>
                                    <option value={'day(s)'}>day(s)</option>
                                </select>
                                </div>
                            </div>

                            <div className="col-12 appointment-create-form__row appointment-create-form__row--dob">
                                <label htmlFor="dob" className="appointment-create-form__label">
                                    Date of birth<span className="text-danger">*</span>
                                    <span className="appointment-create-form__hint">dd/mm/yyyy</span>
                                </label>
                                <input
                                    required
                                    className="form-control input appointment-create-form__control"
                                    autoComplete="off"
                                    type="date"
                                    id="dob"
                                    name="dob"
                                    value={info?.dob?.slice(0, 10) || ""}
                                    onChange={(e) => {
                                        setDobAgeInfoFun("dob", e.target.value);
                                    }}
                                />
                            </div>

                            <div className="col-12 appointment-create-form__row appointment-create-form__row--referral">
                                <label className="appointment-create-form__label appointment-create-form__label--top">
                                    Referred by
                                </label>
                                <div className="appointment-create-form__referral-stack w-100">
                                    <div className="my-0 py-0">
                                        <CreatableSearchSelect options={referralList} setOptionFun={setRefferalListFun} handleSubmit={handleAddToPrescription}
                                            handleCreate={handleCreateReferral}
                                        ></CreatableSearchSelect>
                                    </div>
                                    <textarea
                                        rows={2}
                                        className="form-control input appointment-create-form__textarea"
                                        autoComplete="off"
                                        value={referral || ""}
                                        placeholder="Referral notes"
                                        onChange={(e) => setReferral(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="col-12 appointment-create-form__row appointment-create-form__row--district">
                                <label htmlFor="district-select" className="appointment-create-form__label">
                                    District
                                </label>
                                <div className="appointment-create-form__district w-100">
                                    <Select
                                        id="district-select"
                                        style={{ width: "100%" }}
                                        showSearch
                                        placeholder="Select a district"
                                        optionFilterProp="label"
                                        onChange={onChange}
                                        value={{ label: seletedDistrict?.label, value: seletedDistrict._id }}
                                        options={districtList}
                                    />
                                </div>
                            </div>

                            <div className="col-12 appointment-create-form__row appointment-create-form__row--address">
                                <label htmlFor="address" className="appointment-create-form__label appointment-create-form__label--top">
                                    Address
                                </label>
                                <textarea
                                    rows={2}
                                    id="address"
                                    className="form-control input appointment-create-form__textarea"
                                    autoComplete="off"
                                    name="address"
                                    value={info?.address || ""}
                                    placeholder="Street, area"
                                    onChange={(e) => {
                                        setInfoFun("address", e.target.value);
                                    }}
                                />
                            </div>

                            <div className="col-12 appointment-create-form__row">
                                <label className="appointment-create-form__label">
                                    Occupation
                                </label>
                                <div className="w-100" key={3}>
                                    <SelectWithLocalSearch currentValue={occupationLabel} name="profession" handleFormValues={(profession) => {
                                        setInfoFun("profession", profession?.name);
                                    }} isCreatable={true} handleCreate={handleCreateOccupation} options={occupationList} placeHolder='Select occupation'></SelectWithLocalSearch>
                                </div>
                            </div>

                            <div className="col-12 appointment-create-form__row">
                                <label htmlFor="bloodGroup" className="appointment-create-form__label">
                                    Blood group
                                </label>
                                <select
                                    id="bloodGroup"
                                    className="appointment-create-form__control appointment-create-form__control--full"
                                    onChange={(e) => {
                                        setInfoFun("bloodGroup", e.target.value);
                                    }}
                                    value={info?.bloodGroup || ""}
                                >
                                    <option value={""}>Select</option>
                                    <option value={'A+'}>A+</option>
                                    <option value={'A-'}>A-</option>
                                    <option value={'B+'}>B+</option>
                                    <option value={'B-'}>B-</option>
                                    <option value={'AB+'}>AB+</option>
                                    <option value={'AB-'}>AB-</option>
                                    <option value={'O+'}>O+</option>
                                    <option value={'O-'}>O-</option>
                                </select>
                            </div>
                            <div className="col-12 appointment-create-form__row appointment-create-form__row--radios">
                                <span id="gender-group" className="appointment-create-form__label">
                                    Gender<span className="text-danger">*</span>
                                </span>
                                    <div
                                        role="group"
                                        aria-labelledby="gender-group"
                                        className="appointment-create-form__radio-group"
                                    >
                                        <label className="appointment-create-form__radio">
                                            <input
                                                checked={
                                                    info?.gender?.toLowerCase() === "male"
                                                }
                                                type="radio"
                                                name="gender"
                                                value="Male"
                                                required={info?.gender?.length <= 0}
                                                onClick={() => {
                                                    setInfoFun("gender", "Male");
                                                }}
                                            />
                                            <span>Male</span>
                                        </label>
                                        <label className="appointment-create-form__radio">
                                            <input
                                                checked={
                                                    info?.gender?.toLowerCase() === "female"
                                                }
                                                required={info?.gender?.length <= 0}
                                                type="radio"
                                                name="gender"
                                                value="Female"
                                                onClick={() => {
                                                    setInfoFun("gender", "Female");
                                                }}
                                            />
                                            <span>Female</span>
                                        </label>
                                    </div>
                            </div>
                            <div className="col-12 appointment-create-form__row">
                                <label className="appointment-create-form__label">
                                    Marital status
                                </label>
                                <div className="mt-0 pt-0 w-100 " key={3}>
                                    <SelectWithLocalSearch currentValue={info?.maritalStatus} name="maritalStatus"
                                        handleFormValues={(status) => {
                                            setInfoFun("maritalStatus", status?.value);
                                        }} isCreatable={false} options={maritalStatusOptions}
                                        placeHolder='Select marital status'></SelectWithLocalSearch>
                                </div>
                            </div>
                            </div>
                            <div className="col-12 appointment-create-form__panel">
                            <h3 className="appointment-create-form__section-title">Appointment</h3>
                            {user?.user?.type?.toLowerCase() !== "doctor" &&
                                <div className="col-12 appointment-create-form__row">
                                    <label className="appointment-create-form__label">
                                        Doctor<span className="text-danger">*</span>
                                    </label>
                                    <div className="w-100" key={2}>
                                        <SelectWithLocalSearch required={true} currentValue={selectedDoctor?.name || ""}
                                            isDisabled={!selectedRole?.parentUsers?.length}
                                            name="doctor" handleFormValues={(doctor) => {
                                                setInfoFun("doctorId", doctor?._id);
                                            }} isCreatable={false} options={selectedRole?.parentUsers || []}
                                            placeHolder='Select doctor'></SelectWithLocalSearch>
                                    </div>
                                </div>}
                            <div className="col-12 appointment-create-form__row">
                                <label htmlFor="appointmentDate" className="appointment-create-form__label">
                                    Appointment date<span className="text-danger">*</span>
                                </label>
                                <input
                                    required
                                    className="form-control input appointment-create-form__control"
                                    autoComplete="off"
                                    type="date"
                                    id="appointmentDate"
                                    name="appointmentDate"
                                    value={info?.appointmentDate?.slice(0, 10)}
                                    onChange={(e) => {
                                        setInfoFun("appointmentDate", e.target.value);
                                    }}
                                />
                            </div>
                            <div className="col-12 appointment-create-form__row appointment-create-form__row--type">
                                <span id="appointment-type-group" className="appointment-create-form__label">
                                    Visit type<span className="text-danger">*</span>
                                </span>
                                    <div
                                        role="radiogroup"
                                        aria-labelledby="appointment-type-group"
                                        aria-required="true"
                                        className="appointment-create-form__radio-group appointment-create-form__radio-group--wrap"
                                    >
                                        <label className="appointment-create-form__radio">
                                            <input
                                                type="radio"
                                                name="appointmentType"
                                                value="new"
                                                checked={info?.type === "new"}
                                                onChange={() => {
                                                    setInfoFun("type", "new");
                                                }}
                                            />
                                            <span>New</span>
                                        </label>
                                        <label className="appointment-create-form__radio">
                                            <input
                                                type="radio"
                                                name="appointmentType"
                                                value="old"
                                                checked={info?.type === "old"}
                                                onChange={() => {
                                                    setInfoFun("type", "old");
                                                }}
                                            />
                                            <span>Old</span>
                                        </label>
                                        <label className="appointment-create-form__radio">
                                            <input
                                                type="radio"
                                                name="appointmentType"
                                                value="followUp"
                                                checked={info?.type === "followUp"}
                                                onChange={() => {
                                                    setInfoFun("type", "followUp");
                                                }}
                                            />
                                            <span>Follow up</span>
                                        </label>
                                    </div>
                            </div>
                            </div>

                            <div className="col-12 appointment-create-form__actions">
                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    className="btn submit-button appointment-create-form__submit"
                                >
                                    Create appointment
                                    {isSubmitting && (
                                        <span
                                            className="spinner-border spinner-border-sm ms-2"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    )}
                                </button>
                            </div>
                        </div>
                    </Form>
                </div>
            )}
        </Formik>
    );
};

export default AppointmentCreateForm;
